import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ConcatPipe} from './concat.pipe';
import { HighlitePipe } from './highlite.pipe';

@NgModule({
  declarations: [
    ConcatPipe,
    HighlitePipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    ConcatPipe,
    HighlitePipe
  ]
})
export class PipesModule { }
